<template>
    <toolbar-option type="stacked">
        <template slot="primary">
            <dropdown
                :value="value"
                :options="options"
                native
                @input="onInput"
            />
        </template>
    </toolbar-option>
</template>

<script>
import baseOption from '@/options/mixins/base-option';

export default {
    name: 'carousel-transition-effect',

    mixins: [baseOption],

    data() {
        return {
            displayName: 'Transition Effect',
            value: '',
        };
    },

    computed: {
        options() {
            return [
                { value: 'slide', text: 'slide' },
                { value: 'slide reverse', text: 'slide reverse' },
                { value: 'fade', text: 'fade' },
            ];
        },
    },

    methods: {
        onInput(valueNew) {
            this.value = valueNew;
            this.selectedElements[0].setElementData('carousel-transition-effect', this.value);
            this.onOptionChange(valueNew);
        },

        onSelectedElement() {
            const backgroundPosition = this.selectedElements[0].getElementData('carousel-transition-effect');

            if (backgroundPosition) {
                this.value = backgroundPosition;
            }
        },
    },
};
</script>
